import { makeStyles } from "@material-ui/styles";
import { CELL_HEIGHTS, CELL_PADDING } from "@utils";

export default makeStyles(() => ({
  root: {
    zIndex: 3,
    height: CELL_HEIGHTS.XXLARGE * 4 + CELL_PADDING * 8,
    pointerEvents: "auto",
  },
}));
